import {IconButton} from 'platform/components';
import {Box, Heading, Link, Show} from 'platform/foundation';

import {ReactElement, isValidElement} from 'react';

import {isNil, isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface PairedRecordSnippetTitleProps extends TestIdProps {
  title?: string | ReactElement;
  onOpenDetail?: () => void;
  onEdit?: () => void;
}

/**
 * Snippet title for the paired record: the entity code links to its detail and,
 * while the audit is editable, an edit button reopens the pairing dialog.
 */
export function PairedRecordSnippetTitle(props: PairedRecordSnippetTitleProps) {
  return (
    <>
      {isValidElement(props.title) ? props.title : null}
      <Show
        when={
          isNotNil(props.title) && !isValidElement(props.title) && isNotNil(props.onOpenDetail)
            ? props.title
            : null
        }
      >
        {(title) => (
          <Link
            size="small"
            title={title}
            onClick={props.onOpenDetail}
            data-testid={suffixTestId('link', props)}
          />
        )}
      </Show>
      <Show
        when={
          isNotNil(props.title) && !isValidElement(props.title) && isNil(props.onOpenDetail)
            ? props.title
            : null
        }
      >
        {(title) => (
          <Heading size={5} headingLevel={6} data-testid={suffixTestId('heading', props)}>
            {title}
          </Heading>
        )}
      </Show>
      {/* Pinned to the snippet box's top-right corner (the box is position:relative) so the edit
          affordance sits in the same place regardless of how many parameter lines push the
          vertically-centered content — matching the branch snippet. */}
      <Show when={isNotNil(props.onEdit)}>
        <Box position="absolute" top={2} right={2}>
          <IconButton
            icon="image/edit"
            size="small"
            onClick={props.onEdit}
            aria-label={i18n.t('page.recordAudit.pairing.changeCta')}
            data-testid={suffixTestId('edit', props)}
          />
        </Box>
      </Show>
    </>
  );
}
